import { IStyle } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes, FontWeights, Sizes } from '../../themes/styles';
import { CommonStyles } from '../../themes/themes';

export interface IWidgetItemStyles {
  root: IStyle;
  content: IStyle;
  icon: IStyle;
  body: IStyle;
  title: IStyle;
  description: IStyle;
  status: IStyle;
  descriptionText: IStyle;
  actions: IStyle;
}

export interface IWidgetItemClassNames {
  root: string;
  content: string;
  body: string;
  icon: string;
  title: string;
  description: string;
  descriptionText: string;
  status: string;
  actions: string;
}

export const widgetItemStylesDefault = (theme: IH2OTheme): Partial<IWidgetItemStyles> => ({
  root: {
    display: 'flex',
    padding: '11px 16px',
    overflow: 'hidden',
    borderTop: `1px solid transparent`,
    borderBottom: `1px solid ${theme.palette?.gray200}`,
    '&.selected': {
      borderTopColor: theme.palette?.gray200,
      backgroundColor: theme.palette?.gray200,
    },
    '&.clickable-content': {
      '.h2o-WidgetItem-content': {
        cursor: 'pointer',
      },
    },
    '&.last': {
      borderBottomColor: 'transparent',
    },
    '&.disabled': {
      opacity: 0.5,
      '.h2o-WidgetItem-content': {
        cursor: 'not-allowed',
      },
    },
  },
  icon: {
    width: 40,
    height: 40,
    lineHeight: 40,
    textAlign: 'center',
    borderRadius: Sizes.borderRadius,
    marginRight: 8,
    backgroundColor: theme.palette?.primary500,
    color: theme.palette?.white,
    fontSize: FontSizes.medium,
  },
  content: {
    ...CommonStyles.containerButton,
    overflow: 'hidden',
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
  },
  body: { flex: 1, overflow: 'hidden', lineHeight: 20 },
  title: {
    fontSize: FontSizes.textPrimary,
    fontWeight: FontWeights.semiBold,
    ...CommonStyles.truncateString,
    '&[role="button"]': { cursor: 'pointer' },
    '&[href]': { color: 'unset' },
  },
  description: {
    display: 'flex',
  },
  descriptionText: {
    color: theme.semanticColors?.textSecondary,
    ...CommonStyles.truncateString,
  },
  actions: {
    marginLeft: 8,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
});

export const widgetItemStylesList = (theme: IH2OTheme): Partial<IWidgetItemStyles> => ({
  root: {
    padding: '7px 20px',
    border: `1px solid transparent`,
    '&:hover': {
      backgroundColor: theme.palette?.primary100,
      border: `1px solid ${theme.palette?.primary500}`,
    },
  },
  icon: {
    marginRight: Sizes.padding,
  },
});
